import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-explainer",
  "use": "icon-explainer-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-explainer\">\n  <path fill=\"currentColor\" d=\"M10.6 8.199H9.4v-1.2h1.2v1.2z\" />\n  <path fill=\"currentColor\" d=\"M10 16c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6zm0-10.8A4.805 4.805 0 005.2 10c0 2.647 2.153 4.8 4.8 4.8s4.8-2.153 4.8-4.8-2.153-4.8-4.8-4.8z\" />\n  <path fill=\"currentColor\" d=\"M10.6 12.399H9.4v-3h1.2v3zm-1.2-2.4h-.6v-.6h.6v.6z\" />\n  <path fill=\"currentColor\" d=\"M11.2 12.399H8.8v-.6h2.4v.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol